export const SUPPORT_EMAIL = 'hana-bot@hanabitech.com';
export const DEVELOPER_NAME = 'Hanabi Technologies';
export const DEVELOPER_DOMAIN = 'hanabitech.com';
